var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6366 2.39619C13.2411 2.16687 13.8331 2.75887 13.6038 3.36343L9.51932 14.1316C9.26243 14.8089 8.28987 14.7646 8.09556 14.0669L6.75325 9.24675L1.93314 7.90444C1.23538 7.71013 1.19112 6.73757 1.86836 6.48068L12.6366 2.39619Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturnArrow);
export default __webpack_public_path__ + "static/media/icon-return-arrow.b726bb28a718d27bbf2e11e841667a59.svg";
export { ForwardRef as ReactComponent };